"use client";
import React from "react";

import { Box, BoxSx } from "../../foundations";
import { BRAND_LOGOS } from "./BrandLogoConsts";

type LogoProps = {
  logo: keyof typeof BRAND_LOGOS;
  sx?: BoxSx;
} & React.ComponentProps<typeof Box>;

export const Logo: React.FC<LogoProps> = (props: LogoProps) => {
  const { logo, sx } = props;

  const LogoSource = BRAND_LOGOS[logo];

  return <LogoSource sx={sx} />;
};
